import { useQuery } from '@tanstack/react-query';
import { backlinksApi } from '../services/contactsApi';

export const backlinksKeys = {
  all: ['backlinks'] as const,
  contactCounts: (contactId: string) => [...backlinksKeys.all, 'contact', contactId, 'counts'] as const,
  contactDeals: (contactId: string) => [...backlinksKeys.all, 'contact', contactId, 'deals'] as const,
  contactTickets: (contactId: string) => [...backlinksKeys.all, 'contact', contactId, 'tickets'] as const,
  companyCounts: (organizationId: string) => [...backlinksKeys.all, 'company', organizationId, 'counts'] as const,
  companyDeals: (organizationId: string) => [...backlinksKeys.all, 'company', organizationId, 'deals'] as const,
  companyTickets: (organizationId: string) => [...backlinksKeys.all, 'company', organizationId, 'tickets'] as const,
};

// Contact backlinks hooks

export function useContactRelatedCounts(contactId: string) {
  return useQuery({
    queryKey: backlinksKeys.contactCounts(contactId),
    queryFn: () => backlinksApi.getContactRelatedCounts(contactId),
    enabled: !!contactId,
  });
}

export function useContactDeals(contactId: string, params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: [...backlinksKeys.contactDeals(contactId), params],
    queryFn: () => backlinksApi.listContactDeals(contactId, params),
    enabled: !!contactId,
  });
}

export function useContactTickets(contactId: string, params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: [...backlinksKeys.contactTickets(contactId), params],
    queryFn: () => backlinksApi.listContactTickets(contactId, params),
    enabled: !!contactId,
  });
}

// Organization backlinks hooks

export function useOrganizationRelatedCounts(organizationId: string) {
  return useQuery({
    queryKey: backlinksKeys.companyCounts(organizationId),
    queryFn: () => backlinksApi.getCompanyRelatedCounts(organizationId),
    enabled: !!organizationId,
  });
}

export function useOrganizationDeals(organizationId: string, params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: [...backlinksKeys.companyDeals(organizationId), params],
    queryFn: () => backlinksApi.listCompanyDeals(organizationId, params),
    enabled: !!organizationId,
  });
}

export function useOrganizationTickets(organizationId: string, params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: [...backlinksKeys.companyTickets(organizationId), params],
    queryFn: () => backlinksApi.listCompanyTickets(organizationId, params),
    enabled: !!organizationId,
  });
}
